<template>
  <ion-page>
    <ion-content>
      <div class="ion-padding">
        <DeviceForm :serial-number="device.serialNumber" ref="form" />
      </div>
    </ion-content>
    <ion-footer>
      <ion-toolbar>
        <gro-button fill="clear"
                    @click="close">{{ $t('common.Cancel') }}
        </gro-button>
        <ion-buttons slot="end">
           <gro-button @click="deleteDevice"
                      color="danger">{{ $t('device.Delete') }}
          </gro-button>
          <gro-button @click="save">{{ $t('common.Save') }}</gro-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-footer>
  </ion-page>
</template>

<script>
import DeviceForm from '~gro-components/forms/DeviceForm'

export default {
  components: {
    DeviceForm,
  },
  props: {
    device: {
      type: Object,
      required: true,
    },
    refetch: {
      type: Function,
    },
  },
  methods: {
    close () {
      this.$dismissAllModals()
    },
    async save () {
      if (await this.$refs.form.submit()) {
        await this.refetch()
        return this.close()
      }
    },
    async deleteDevice () {
      if (await this.$refs.form.deleteDevice()) {
        await this.refetch()
        return this.close()
      }
    },
  },
}
</script>
